import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import WorkInProgress from "../WorkInProgress";
import Terms from "./TermsAndCondition";
import PrivacyPolicy from "./PrivacyPolicy";
import ContactUs from "./ContactDetails";
import StatisticsManagementTab from "./StatisticsManagement";

const ContentManagement = () => {
  const [currentTab, setcurrentTab] = useState(0);
  const Tabs = [
    { id: 0, name: "Terms & Conditions", data: <Terms /> },
    { id: 1, name: "Privacy Policy", data: <PrivacyPolicy /> },
    { id: 2, name: "Contact Details", data: <ContactUs /> },
    { id: 3, name: "Statistics", data: <StatisticsManagementTab /> },
  ];
  return (
    <Box sx={{ height: "calc(100vh - 32px)" }}>
      <Box
        sx={{
          height: "110px",
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #CED7E4",
          px: 2,
        }}
      >
        {/* <Box> */}
        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 500,
          }}
        >
          Content Management
        </Typography>
      </Box>
      <Box
        sx={{
          background: "#F4F4F4",
          height: "calc(100% - 80px)",
          width: "100%",
          p: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 3, p: 2 }}>
          {Tabs.map((x, i) => (
            <Box key={i + "tabs"}>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 500,
                  cursor: "pointer",
                  color: currentTab === x.id && "#F57C00",
                }}
                onClick={() => setcurrentTab(i)}
              >
                {x.name}
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  borderBottom: "2px solid #F57C00",
                  display: currentTab !== x.id && "none",
                }}
              />
            </Box>
          ))}
        </Box>
        <Box>{Tabs[currentTab].data}</Box>
      </Box>
    </Box>
  );
};

export default ContentManagement;
